import { ECDSAKeyIdentity } from "@icp-sdk/core/identity";
const KEY_STORAGE_EMAIL_LINK = "email_link";
const KEY_STORAGE_EMAIL_LINK_CONTEXT = "email_link_context";
export async function storeEmailSignInSession(storage, session) {
    await storage.set(KEY_STORAGE_EMAIL_LINK, session.key.getKeyPair());
    await storage.set(KEY_STORAGE_EMAIL_LINK_CONTEXT, JSON.stringify({
        email: session.email,
        userKey: Array.from(session.userKey),
        expiration: session.expiration.toString(),
    }));
}
export async function getEmailSignInSession(storage) {
    const keyPair = (await storage.get(KEY_STORAGE_EMAIL_LINK));
    if (keyPair == null)
        return undefined;
    const contextString = (await storage.get(KEY_STORAGE_EMAIL_LINK_CONTEXT));
    if (contextString == null)
        return undefined;
    const key = await ECDSAKeyIdentity.fromKeyPair(keyPair);
    const context = JSON.parse(contextString);
    return {
        key,
        email: context.email,
        userKey: Uint8Array.from(context.userKey),
        expiration: BigInt(context.expiration),
    };
}
export async function removeEmailSignInSession(storage) {
    storage.remove(KEY_STORAGE_EMAIL_LINK);
    storage.remove(KEY_STORAGE_EMAIL_LINK_CONTEXT);
}
